module.exports = __webpack_public_path__ + "img/kids-2.53c9b573.jpg";